import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import { UsersModel } from '@/features/tenant-manager/models';
import type { z } from 'zod';
import { queryKeyMap } from '../review-sheet/utils/query-keys';

/**
 * Obtain the following users information associated with the project
 * businessManagerIds
 */

export const useBusinessManagers = <T = z.infer<typeof UsersModel>>({
  projectId,
  select,
}: {
  projectId: string;
  select?: (data: z.infer<typeof UsersModel>) => T;
}) => {
  return useQuery({
    queryKey: queryKeyMap.projectBusinessManagers(projectId),
    queryFn: async () => {
      const businessManagers = await axiosGet(
        `/api/projects/${projectId}/business-managers/`,
      );
      return UsersModel.parse(businessManagers);
    },
    select,
    enabled: !!projectId,
  });
};
